import React, { Component } from "react";
import { connect } from "react-redux";
import { EditItem } from "./EditItem";
import { WaslShortList } from "./WaslShortList";
// import { Trans as Translate} from 'react-i18next';
import Loader from "../../Layout/Loader";
import isEqual from "react-fast-compare";
import {
  // removedvehicle,
  updatevehicle,
  addvehicle,
} from "../../Actions/Vehicles";
import AddVehicle from "./addVehicle";
import ConfirmDialoag from "../common/ConfirmDialoag";

import axios from "axios";
import instance from "../../axios";
import { checkPrivileges, errorHandler } from "../../Helpers";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { notifyError, notifySuccess } from "../../Utils/CustomNotifcations";
import {
  getVinConfirmPreview,
  getVinDetailEntries,
  normalizeVinFuelType,
  normalizeVinTransmission,
  parseVinDecoderResponse,
  resolveVinCategory,
} from "./vinDecoderHelpers";

const vehicleDataFormat = (data, itemId, user) => ({
  id: itemId ? itemId : 0,
  attributes: {
    ...data.attributes,
    capacity: data.attributes.capacity || "0",
    createdBy: user?.id,
  },
  deviceId: data.deviceId || 0,
  // totalAvailablekm: data.totalAvailablekm || 0,
  totalAvailablekm: data.totalAvailablekm
    ? parseFloat(data.totalAvailablekm)
    : 200,
  label: data.label,
  modelId: data?.modelId?.id || 0,
  fuelEfficiency: data.fuelEfficiency ? parseFloat(data.fuelEfficiency) : 0,
  odometer: data.odometer ? parseFloat(data.odometer) : 0,
  entitlement: data.entitlement ? parseFloat(data.entitlement) : 0,
  garage: data.garage,
  // vehicleType: data.vehicleType,
  vin: data.vin,
  vehicleLicensePlate: data.vehicleLicensePlate,
  leasePeriod: data && data.leasePeriod ? parseInt(data.leasePeriod) : 0,
  vehicleLisencePlateArabic: data.vehicleLisencePlateArabic,
  expirationTime: data.expirationTime,
  insuranceTime: data.insuranceTime,
  complianceTime: data.complianceTime,
  monthlyRate: data && data.monthlyRate ? parseFloat(data.monthlyRate) : 0,
  purchasePrice:
    data && data.purchasePrice ? parseFloat(data.purchasePrice) : 0,
  purchaseDate: data?.purchaseDate || "",
  deliveryDate: data?.deliveryDate || "",
  leaseEndDate: data?.leaseEndDate || "",
  leaseStartDate: data?.leaseStartDate || "",
  areaId: data && data.areaId ? data.areaId.id : 0,
  category: data && data.category ? data.category : "",
  imei: data && data.imei ? data.imei : "",
  unitIcon: data && data.unitIcon ? data.unitIcon : "",
  onLease: data && data.onLease ? data.onLease : false,
  cityId: data && data?.cityId ? data?.cityId?.id : 1,
  // parentId:data && data.parentId ? data.parentId.id : user&&user.id?user.id : 0
  parentId:
    user?.userType === 1 || user?.userType === 2
      ? 0
      : data?.parentId?.id || user?.id || 0,
  carbonFootPrint: data && data.carbonFootPrint ? data.carbonFootPrint : 0,
});

const trasmissionList = [{ name: "Manual" }, { name: "Automatic" }];
const fuel_typeList = [
  { name: "PETROL", key: "PETROL" },
  { name: "DIESEL", key: "DIESEL" },
  { name: "ETHANOL", key: "ETHANOL" },
  { name: "BIODIESEL", key: "BIODIESEL" },
  { name: "CNG", key: "CNG" },
  { name: "LPG", key: "LPG" },
  { name: "HYDROGEN", key: "HYDROGEN" },
  { name: "HYBRID", key: "HYBRID" },
  { name: "PHEV", key: "PHEV" },
  { name: "ELECTRIC", key: "ELECTRIC" },
  { name: "OTHERS", key: "OTHERS" },
];
const formDefault = {
  label: "",
  garage: "",
  model: "",
  // vehicleType: "",
  parentId: "",
  expirationTime: "",
  vehicleLicensePlate: "",
  vehicleLisencePlateArabic: "",
  leasePeriod: "",
  onLease: false,
  fuelEfficiency: "",
  category: "",
  imei: "",
  unitIcon: "",
  attributes: { typeName: ["Maintenance"] }, //vehicleLicensePlate: ''
  carbonFootPrint: 0,
  odometer: 0,
  entitlement: 0,
  totalAvailablekm: 200,
};
let fuel_type = "";
class vehicleModal extends Component {
  constructor() {
    super();
    this.state = {
      trasmissionList: trasmissionList,
      fuel_typeList: fuel_typeList,
      selectedVehicle: "",
      addOption: false,
      editOption: false,
      isVisableTrackerModal: false,
      isVisableUserBtn: false,
      vehicleId: "",
      vehicleTracker: "",
      form: { ...formDefault },
      vehicleStatus: "",
      allMakes: [],
      makesLoading: false,
      selectedMakeTypes: [],
      minPercentage: 1,
      maxPercentage: 100,
      categoriesList: [],
      unitIconList: [],
      vehicleLicensePlateError: false,
      yearError: false,
      isVin: false,
      vinError: "",
      showVinConfirmDialog: false,
      pendingVinVehicleData: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.ac_submit = this.ac_submit.bind(this);
    this.onCloseSubModal = this.onCloseSubModal.bind(this);
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
    this.makesPaginationRef = {
      page: 1,
      hasNext: false,
      search: "",
      loading: false,
    };
    this.makeSearchTimeout = null;
  }
  componentWillMount() {
    this.dataFormatting();
    this.fetchCategories();
    this.fetchUnitIcons();
    this.fetchMake();
  }

  componentWillUnmount() {
    if (this.makeSearchTimeout) {
      clearTimeout(this.makeSearchTimeout);
    }
  }

  fetchCategories = () => {
    instance(`/api/vehiclecategorys/get?page=1&limit=500&category=`)
      .then((response) => {
        const categories = [
          ...new Set(
            (response?.data || [])
              .map((item) => item?.categoryName)
              .filter(Boolean),
          ),
        ];
        this.setState((prevState) => {
          const formCategory =
            prevState.form?.category || prevState.selectedVehicle?.category;
          const resolvedCategory = this.resolveCategory(
            formCategory,
            categories,
          );
          return {
            categoriesList: categories,
            form:
              prevState.form && resolvedCategory
                ? { ...prevState.form, category: resolvedCategory }
                : prevState.form,
          };
        });
      })
      .catch((error) => {
        // errorHandler(error, this.props.dispatch)
      });
  };

  fetchUnitIcons = () => {
    instance(`/api/devices/categories`)
      .then((response) => {
        this.setState({ unitIconList: response?.categories || [] });
      })
      .catch((error) => {
        // errorHandler(error, this.props.dispatch)
      });
  };

  // Match API category to dropdown option (case-insensitive), e.g. "VAN" -> "VAN"/"Van"
  resolveCategory = (
    apiCategory,
    categoriesList = this.state.categoriesList,
  ) => {
    if (!apiCategory) return "";
    if (!categoriesList?.length) return apiCategory;
    const match = categoriesList.find(
      (option) =>
        String(option).toLowerCase() === String(apiCategory).toLowerCase(),
    );
    return match || apiCategory;
  };
  dataFormatting = async () => {
    let findAreaId =
      this.props.areaList &&
      this.props.areaList.find(
        (item) =>
          item.key ===
          (this.props.selecteditem && this.props.selecteditem.areaId),
      );
    let dt = JSON.parse(JSON.stringify(this.props.selecteditem));
    const device = this.props.devices.find((d) => d.id === dt.deviceId);
    const cityId = dt?.cityId
      ? this.props.cities.find((item) => item.id === dt.cityId)
      : 0;
    if (this.props.showItemDetail && this.props.trackersApiResponce) {
      let formData = this.setFormData(dt);

      let attributes = dt.attributes;
      let trackers = this.props.trackerData;
      formData = { ...formData, cityId, attributes, trackers };
      this.setState({
        selectedVehicle: formData,
        vehicleId: dt.id,
        // vehicleTracker: this.props.trackerData
        vehicleTracker: this.props.trackerData
          ? this.props.trackerData
          : device
            ? {
                value: device.id,
                label: device.name,
                uniqueId: device?.uniqueId,
              }
            : "",
      });
    } else {
      if (
        this.props.activeOperation === "edit" &&
        this.props.trackersApiResponce
      ) {
        if (
          !this.state.editOption ||
          !isEqual(this.state.selectedVehicle, dt)
        ) {
          const category = this.resolveCategory(dt?.category);
          this.setState({
            form: {
              ...dt,
              parentId: this.props.selectedUser,
              cityId,
              areaId: findAreaId,
              category: category,
            },
            vinError:
              dt?.vin &&
              (dt?.vin.trim().length !== 17 || !/^[A-Za-z0-9]+$/.test(dt?.vin))
                ? "VIN must be exactly 17 characters long and contain only alphanumeric characters."
                : "",

            isVin:
              dt?.vin &&
              dt?.vin.trim().length === 17 &&
              /^[A-Za-z0-9]+$/.test(dt?.vin),

            vehicleId: dt.id,
            editOption: true,
            addOption: false,
            selectedVehicle: dt,
            // vehicleTracker: this.props.trackerData
            vehicleTracker: this.props.trackerData
              ? this.props.trackerData
              : device
                ? {
                    value: device.id,
                    label: device.name,
                    uniqueId: device?.uniqueId,
                  }
                : "",
          });
        }
      }
      if (this.props.activeOperation === "add" && !this.state.addOption) {
        this.setState({
          vehicleTracker: "",
          vehicleId: "",
          selectedVehicle: "",
          addOption: true,
          editOption: false,
          waslLinked: true,
          form: { ...formDefault, attributes: {} },
          isVin: false,
          vinError: "",
          showVinConfirmDialog: false,
          pendingVinVehicleData: null,
        });
      }
    }
  };

  setFormData = (data) => {
    let formData = {
      label: data.label,
      garage: data.garage,
      model: data.model,
      // vehicleType: data.vehicleType,
      expirationTime: data.expirationTime,
      insuranceTime: data.insuranceTime,
      complianceTime: data.complianceTime,
      vehicleLicensePlate: data.vehicleLicensePlate || "",
      vehicleLisencePlateArabic: data.vehicleLisencePlateArabic || "",
      leasePeriod: data.leasePeriod || "",
      vin: data?.vin || data?.attributes?.vin || "",
      chassisNumber: data.attributes.chassisNumber || "",
      permittedSpeed: data.attributes.permittedSpeed || "",
    };
    return formData;
  };
  ac_submit() {
    let { form } = this.state;
    const obj = vehicleDataFormat(form, 0, this.props.logInUsers);
    this.setState({
      isVisableUserBtn: false,
    });

    // fetch('/api/vehicles', {
    //   method: 'POST',
    //   headers: {
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     ...obj
    //   })
    // })
    instance({
      url: `/api/vehicles`,
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {
        ...obj,
      },
    })
      // .then(response => {
      //   if (response.ok) {
      //     response.json()
      .then((data) => {
        if (data.status === "success") {
          this.props.dispatch(addvehicle(data.data));
          this.props.onCloseModal();
          this.setState({
            addOption: false,
            selectedVehicle: "",
            form: formDefault,
          });

          this.props.dispatch(notifySuccess("vehicleIsAdded"));
        } else {
          if (
            data &&
            data.message &&
            data.message.includes("vehicles_deviceid")
          ) {
            this.props.dispatch(notifyError("alreadyAttachedWithVehicle"));
          } else {
            this.props.dispatch(
              notifyError("vehicleLicensePlateAllreadyInUsed"),
            );
          }
        }
      })
      //   } else {
      //     throw response
      //   }
      // })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
      });
    // .catch(e => {
    //   this.props.dispatch(
    //     Notifications.error({
    //       message: this.props.translate('vehicleFormateIssue'),
    //       autoDismiss: 10
    //     })
    //   )
    // })
  }
  uc_submit = (disableWaslCall) => {
    let {
      form,
      selectedVehicle: { id },
    } = this.state;
    const { waslEnabled } = this.props?.serversettings?.attributes || {};
    if (waslEnabled) {
      this.setState({
        waslStatus: (
          <span className="loading-status-text">
            {" "}
            <LoadingIndicator /> Processing
          </span>
        ),
      });
    }
    this.setState({
      vehicleStatus: (
        <span className="loading-status-text">
          <LoadingIndicator /> Processing
        </span>
      ),
    });
    const obj = vehicleDataFormat(form, id, this.props.logInUsers);

    if (!obj.attributes.WASLKey) {
      delete obj.attributes.WASLKey;
    }
    if (!obj.vin) {
      delete obj.vin;
    }
    this.setState({
      isVisableUserBtn: false,
    });
    const data = {
      url: id ? `/api/vehicles/${id}` : `/api/vehicles/`,
      method: id ? `PUT` : `POST`,
      successMsg: id ? `vehicleIsUpdated` : `vehicleIsAdded`,
    };

    instance({
      url: data.url,
      method: data.method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {
        ...obj,
      },
    })
      .then((d) => {
        // if (d.status === 200 && d.data.status === 'success') {
        this.setState({ form: { ...formDefault, attributes: {} } });
        this.props.dispatch(id ? updatevehicle(d) : addvehicle(d));
        if (!disableWaslCall && waslEnabled && this.state.waslLinked) {
          this.submitWasl(obj, d);
        } else {
          this.handleAfterResponse();
        }
        this.props.dispatch(notifySuccess(data.successMsg));
        this.props.fetchData(this.props?.logInUsers?.id, 1, 50, true);
        this.onCloseSubModal();
        // if (!id) {
        //   this.props?.handleShowUserAccess(d?.id);
        // }
        // }
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
      });
  };

  handleAfterResponse = () => {
    this.setState({
      vehicleStatus: (
        <span className="loading-status-text">
          <DoneAllIcon className="status-icon" /> Done
        </span>
      ),
    });
  };

  onChangedDevice = (item) => {
    if (item) {
      const device = this.props.devices.find((d) => d.id === item.id);

      this.setState(
        {
          vehicleTracker: {
            value:item?.id|| device?.id,
            label:item?.label|| device?.name,
            uniqueId:item?.uniqueId|| device?.uniqueId,
          },
          form: {
            ...this.state.form,
            deviceId: item.value,
          },
        },
        () => this.checkRequiredFields(),
      );
    } else {
      this.setState(
        {
          vehicleTracker: "",
          form: {
            ...this.state.form,
            deviceId: "",
          },
        },
        () => this.checkRequiredFields(),
      );
    }
  };

  enableAssignTrackerModal = () => {
    this.setState({
      isVisableTrackerModal: true,
    });
  };
  onCloseModal = () => {
    this.setState({
      isVisableTrackerModal: false,
    });
  };
  onCloseSubModal() {
    this.setState({
      addOption: false,
      editOption: false,
      showVinConfirmDialog: false,
      pendingVinVehicleData: null,
    });
    this.props.onCloseModal();
  }

  getVehicleData = async () => {
    try {
      const vin = this.state.form?.vin?.trim();
      if (!vin) return;

      const response = await axios.get(
        `/api/trigger/vindecoder2?vin=${encodeURIComponent(vin)}`,
      );
      const vehicleData = parseVinDecoderResponse(response?.data);

      if (!vehicleData) {
        this.props.dispatch(
          notifyError(
            this.props.translate("noRecordFound") || "No Record Found",
          ),
        );
        return;
      }

      this.setState({
        showVinConfirmDialog: true,
        pendingVinVehicleData: vehicleData,
      });
    } catch (error) {
      console.error("VIN decoder error:", error);
      this.props.dispatch(
        notifyError(
          this.props.translate("somethingWentWrong") ||
            "Something went wrong while fetching vehicle data",
        ),
      );
    }
  };

  handleVinConfirmYes = async () => {
    const { pendingVinVehicleData } = this.state;
    if (pendingVinVehicleData) {
      await this.applyVinDecoderData(pendingVinVehicleData);
    }
    this.setState({
      showVinConfirmDialog: false,
      pendingVinVehicleData: null,
    });
  };

  handleVinConfirmNo = () => {
    this.setState({
      showVinConfirmDialog: false,
      pendingVinVehicleData: null,
    });
  };

  getVinConfirmPreviewText = () => {
    return getVinConfirmPreview(this.state.pendingVinVehicleData);
  };

  renderVinConfirmDetails = () => {
    const entries = getVinDetailEntries(this.state.pendingVinVehicleData);
    if (!entries.length) return null;

    return (
      <div style={{ maxHeight: 220, overflowY: "auto", marginTop: 12 }}>
        {entries.map(({ key, label, value }) => (
          <div
            key={key}
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 12,
              padding: "4px 0",
              fontSize: 13,
              borderBottom: "1px solid #eee",
            }}
          >
            <span>{label}</span>
            <span style={{ fontWeight: 600, textAlign: "right" }}>{value}</span>
          </div>
        ))}
      </div>
    );
  };

  applyVinDecoderData = async (vehicleData) => {
    const { form, categoriesList, allMakes } = this.state;
    const attributes = { ...(form.attributes || {}) };

    const maker = vehicleData.maker || vehicleData.make || "";
    const modelName =
      vehicleData.model || vehicleData.modelName || vehicleData.modelId || "";
    const modelYear = vehicleData.modelYear || vehicleData.year;

    let makeOption = form.make || "";
    if (maker) {
      makeOption = {
        id: maker,
        label: maker,
        value: maker,
        key: maker,
      };
      attributes.make = maker;
    }

    if (vehicleData.trim) {
      attributes.variant = vehicleData.trim;
    }

    if (modelYear) {
      attributes.year = String(modelYear);
    }

    const category = resolveVinCategory(vehicleData.bodyType);
    let fuelEfficiency = form.fuelEfficiency;
    if (category) {
      fuelEfficiency =
        (await this.getFuelEfficiency(category)) || fuelEfficiency;
    }

    const fuelType = normalizeVinFuelType(vehicleData.fuelType);
    if (fuelType) {
      attributes.fuel_type = fuelType;
    }

    const transmission = normalizeVinTransmission(vehicleData.transmission);
    if (transmission) {
      attributes.trasmissionType = transmission;
    }

    const color = vehicleData.color || vehicleData.exteriorColor;
    if (color) {
      attributes.color = color;
    }

    if (vehicleData.interiorColor) {
      attributes.interiorColor = vehicleData.interiorColor;
    }

    if (vehicleData.engineSize) {
      attributes.capacity = String(vehicleData.engineSize);
    }

    const country = vehicleData.manufacturedIn || vehicleData.origin;
    if (country) {
      attributes.country = country;
    }

    if (vehicleData.fuelEfficiency) {
      fuelEfficiency = vehicleData.fuelEfficiency;
    }

    const reservedKeys = new Set([
      "maker",
      "make",
      "model",
      "modelName",
      "modelId",
      "modelYear",
      "year",
      "trim",
      "bodyType",
      "fuelType",
      "transmission",
      "color",
      "exteriorColor",
      "interiorColor",
      "engineSize",
      "manufacturedIn",
      "origin",
      "fuelEfficiency",
      "settings",
      "vin",
      "statusCode",
      "status",
      "message",
      "data",
    ]);

    Object.entries(vehicleData).forEach(([key, value]) => {
      if (reservedKeys.has(key) || value === null || value === "") return;
      if (typeof value === "object") return;
      attributes[key] = value;
    });

    if (vehicleData.settings && typeof vehicleData.settings === "object") {
      Object.entries(vehicleData.settings).forEach(([key, value]) => {
        if (value !== null && value !== "") {
          attributes[key] = value;
        }
      });
    }

    let label = form.label;
    if (!label || !String(label).trim()) {
      label = [maker, modelName, modelYear].filter(Boolean).join(" ");
    }

    let selectedMakeTypes = this.state.selectedMakeTypes || [];
    let modelId = form.modelId || {};
    let updatedAllMakes = [...allMakes];
    let updatedCategories = [...categoriesList];

    if (maker) {
      if (!updatedAllMakes.find((item) => item.label === maker)) {
        updatedAllMakes.push(makeOption);
      }

      selectedMakeTypes = (await this.fetchVehicleMake(maker)) || [];

      if (modelName && selectedMakeTypes.length) {
        const normalizedModel = String(modelName).toLowerCase();
        const matchedModel = selectedMakeTypes.find(
          (item) =>
            String(item.modelName || "").toLowerCase() === normalizedModel ||
            String(item.label || "").toLowerCase() === normalizedModel,
        );

        if (matchedModel) {
          modelId = {
            ...matchedModel,
            id: matchedModel.id,
            label: matchedModel.label || matchedModel.modelName,
          };
          attributes.model = matchedModel.modelName || modelName;
        } else {
          attributes.model = modelName;
        }
      } else if (modelName) {
        attributes.model = modelName;
      }
    }

    if (category && !updatedCategories.includes(category)) {
      updatedCategories.push(category);
    }

    const currentYear = new Date().getFullYear();
    const parsedYear = parseInt(attributes.year, 10);
    const yearError =
      attributes.year && (parsedYear < 1950 || parsedYear > currentYear + 1);

    this.setState(
      {
        form: {
          ...form,
          label,
          make: makeOption,
          modelId,
          category: category || form.category,
          fuelEfficiency,
          attributes,
        },
        selectedMakeTypes,
        allMakes: updatedAllMakes,
        categoriesList: updatedCategories,
        yearError: Boolean(yearError),
      },
      () => this.checkRequiredFields(),
    );
  };

  handleChangeLicenseExpDate = (name) => (event) => {
    // if (name === 'expirationTime') {
    this.setState(
      {
        form: {
          ...this.state.form,
          [name]: event ? event.toISOString() : null,
        },
      },
      () => this.checkRequiredFields(),
    );
    // }
    // else if(name === 'purchaseDate' || name === 'deliveryDate' || name === 'leaseEndDate'){
    //   this.setState(
    //     {
    //       form: {
    //         ...this.state.form,
    //         attributes:{
    //           ...this.state.form.attributes,
    //           [name]: event.toISOString()
    //         }
    //       }
    //     },
    //     () => this.checkRequiredFields()
    //   )
    // }
  };
  setExpirationTime = (e) => {
    e.stopPropagation();
    this.setState(
      {
        form: {
          ...this.state.form,
          expirationTime: null,
        },
      },
      () => this.checkRequiredFields(),
    );
  };
  handleChange = async (name, event) => {
    const { target } = event;
    if (target && target.type === "checkbox") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: target.checked,
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "fuel_type") {
      // fuel_type = event.name;
      this.setState(
        {
          form: {
            ...this.state.form,
            attributes: { ...this.state.form.attributes, [name]: event.id },
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "category") {
      let value = target.value;
      let val = await this.props.getFuelEfficiency(value);
      console.log("value", value);
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: value,
            fuelEfficiency: val || 0,
          },
        },
        () => {
          this.checkRequiredFields();
        },
        // () =>{ this.checkRequiredFields(); this.getFuelEfficiency(value) }
      );
    } else if (name === "areaId") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: event,
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "typeName") {
      this.setState({
        form: {
          ...this.state.form,
          attributes: {
            ...this.state.form.attributes,
            typeName: event,
          },
        },
      });
    } else if (name === "parentId") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: event,
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "entitlement") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: target.value,
          },
        },
        () => this.checkRequiredFields(),
      );
    } else {
      let value = target.value.toString();
      if (name === "vin") {
        value = value.slice(0, 17);
      }
      this.setState(
        (prevState) => ({
          form: {
            ...prevState.form,
            [name]: value,
          },
          vinError:
            name === "vin"
              ? value.trim().length !== 17 || !/^[A-Za-z0-9]+$/.test(value)
                ? "VIN must be exactly 17 characters long and contain only alphanumeric characters."
                : ""
              : prevState.vinError,

          isVin:
            name === "vin"
              ? value.trim().length === 17 && /^[A-Za-z0-9]+$/.test(value)
              : prevState.isVin,
        }),
        () => this.checkRequiredFields(),
      );
    }
  };
  handleChangeForAttributesValues = async (name, event, link) => {
    let { attributes } = this.state.form;
    if (name === "year") {
      const year = event.target.value;
      this.setState(
        {
          form: {
            ...this.state.form,
            attributes: {
              ...this.state.form.attributes,
              [name]: year,
            },
          },
        },
        () => {
          const currentYear = new Date().getFullYear(); // keep it as a number
          const parsedYear = parseInt(year, 10);
          const parsedMinYear = 1950;
          if (parsedYear >= parsedMinYear && parsedYear <= currentYear + 1) {
            this.setState(
              {
                yearError: false,
              },
              () => {
                this.checkRequiredFields();
              },
            );
          } else {
            this.setState(
              {
                yearError: true,
              },
              () => {
                this.checkRequiredFields();
              },
            );
          }
          this.checkRequiredFields();
        },
      );
    }
    if (name === "type") {
      this.setState(
        {
          form: {
            ...this.state.form,
            attributes: {
              ...this.state.form.attributes,
              [name]: event.target.checked,
            },
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "make") {
      const z = await this.fetchVehicleMake(event.label);
      this.setState(
        {
          selectedMakeTypes: z,
          form: {
            ...this.state.form,
            [name]: event,
            modelId: {},
            attributes: { ...this.state.form.attributes, make: event.label },
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "modelId") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: event,
            attributes: {
              ...this.state.form.attributes,
              model: event.modelName,
            },
          },
        },
        () => this.checkRequiredFields(),
      );
    } else if (name === "cityId") {
      this.setState(
        {
          form: {
            ...this.state.form,
            [name]: event,
            // Re-validate plate against the newly selected city regex
            vehicleLicensePlate: this.state.form.vehicleLicensePlate || "",
          },
        },
        () => this.checkRequiredFields(),
      );
    }
    //  else if (
    //   name === "insurancePercentage" ||
    //   name === "bankPercentage" ||
    //   name === "resalePercentage" ||
    //   name === "replacement" ||
    //   name === "zakatPercentage"
    // ) {
    //   if (event.target.value > 100) {
    //     event.target.value = 100;
    //   }
    //   if (event.target.value < 0) {
    //     event.target.value = 0;
    //   }
    //   attributes[name] = event.target.value;
    //   this.setState({
    //     form: {
    //       ...this.state.form,
    //       attributes: { ...attributes },
    //     },
    //   });
    // }
    else {
      const target = name === "trasmissionType" ? event : event && event.target;
      let value =
        name === "trasmissionType" ? event : target && target.value.toString();
      if (value) {
        if (
          name === "insurancePercentage" ||
          name === "bankPercentage" ||
          name === "Maintenance" ||
          name === "zakatPercentage" ||
          name === "resalePercentage" ||
          name === "replacement" ||
          name === "otherCost" ||
          name === "fines" ||
          name === "brandingCost" ||
          name === "telematicsCost" ||
          name === "depreciationCost" ||
          name === "driverCost" ||
          name === "standByVehicle"
        ) {
          if (
            name === "insurancePercentage" ||
            name === "bankPercentage" ||
            name === "resalePercentage" ||
            name === "replacement" ||
            name === "zakatPercentage"
          ) {
            if (value > 100) {
              value = 100;
            }
            if (value < 0) {
              value = 0;
            }
          }
          attributes[name] = parseFloat(value);
        } else attributes[name] = value;
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes: { ...attributes },
            },
          },
          () => {
            if (this.state.editOption) {
              this.setState({
                isVisableUserBtn: true,
              });
            }
          },
        );
      } else {
        delete attributes[name];
        this.setState(
          {
            form: {
              ...this.state.form,
              attributes: { ...attributes },
            },
          },
          () => {
            if (this.state.editOption) {
              this.setState({
                isVisableUserBtn: true,
                waslLinked: false,
              });
            }
          },
        );
      }
    }
  };
  async fetchVehicleMake(selectedMake) {
    return await instance({
      method: "GET",
      url: `/api/models/get?page=1&limit=1000&make=${selectedMake}&search= `,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        let defaultOptions =
          response &&
          response.data &&
          response.data.map((item) => {
            return { ...item, label: item.modelName };
          });
        return defaultOptions;
      })
      .catch((error) => {
        errorHandler(error, this.props.dispatch);
      });
  }

  // Cities API may return "s*"/"s+" instead of "\s*"/"\s+" for whitespace.
  normalizeCityPlateRegex = (regexStr) => {
    if (!regexStr) return "";
    return String(regexStr).replace(/(^|[^\\])s([*+])/g, (_, before, quant) => {
      return before + "\\s" + quant;
    });
  };

  isValidLicensePlate = (plate, city) => {
    if (!plate || !String(plate).trim()) return false;
    const plateValue = String(plate).trim();
    const validLicensePlateFormatArabic =
      /^[\u0621-\u064A]\s[\u0621-\u064A]\s[\u0621-\u064A]\s[\d٠-٩]{4}$/;
    if (validLicensePlateFormatArabic.test(plateValue)) {
      return true;
    }

    const selectedCity =
      city && typeof city === "object"
        ? city
        : (this.props.cities || []).find(
            (c) => String(c.id) === String(city),
          ) || null;

    if (!selectedCity?.regex) {
      return false;
    }

    try {
      const pattern = this.normalizeCityPlateRegex(selectedCity.regex);
      return new RegExp(pattern).test(plateValue);
    } catch (e) {
      return false;
    }
  };

  checkRequiredFields() {
    let {
      label,
      vehicleLicensePlate,
      deliveryDate,
      leaseEndDate,
      leaseStartDate,
      onLease,
      make,
      modelId,
      vin,
      category,
      purchaseDate,
      totalAvailablekm,
      parentId,
      cityId,
    } = this.state.form;
    let { fuel_type, year } = this.state.form.attributes;
    let userType = this.props?.logInUsers?.userType;
    let value = true;
    if (this.state.editOption) {
      value = !isEqual(this.state.form, this.props.selecteditem);
    }

    const plateValid = this.isValidLicensePlate(vehicleLicensePlate, cityId);
    this.setState({
      vehicleLicensePlateError: !plateValid,
    });
    if (onLease) {
      if (
        label &&
        label.trim().length &&
        vehicleLicensePlate &&
        vehicleLicensePlate.trim().length &&
        plateValid &&
        deliveryDate &&
        purchaseDate &&
        leaseEndDate &&
        leaseEndDate > leaseStartDate &&
        value &&
        // make &&
        // modelId &&
        vin &&
        this.state.isVin &&
        year &&
        !this.state.yearError &&
        category &&
        fuel_type &&
        // cityId&&
        totalAvailablekm &&
        totalAvailablekm > 0
      ) {
        this.setState({
          isVisableUserBtn: true,
        });
      } else {
        this.setState({
          isVisableUserBtn: false,
        });
      }
    } else {
      if (
        label &&
        label.trim().length &&
        vehicleLicensePlate &&
        vehicleLicensePlate.trim().length &&
        plateValid &&
        // fuel_type !== '' &&
        // fuel_type !== undefined &&
        // deliveryDate &&
        // leaseEndDate&&
        // leaseEndDate > leaseStartDate &&
        value &&
        // make &&
        // modelId &&
        vin &&
        this.state.isVin &&
        year &&
        !this.state.yearError &&
        category &&
        fuel_type &&
        // cityId&&
        totalAvailablekm &&
        totalAvailablekm > 0 &&
        (![4, 5, 6].includes(userType) || (parentId && parentId !== ""))
      ) {
        this.setState({
          isVisableUserBtn: true,
        });
      } else {
        this.setState({
          isVisableUserBtn: false,
        });
      }
    }
  }

  //   checkRequiredFields() {
  //     let { label, vehicleLicensePlate , deliveryDate, leaseEndDate, leaseStartDate, onLease} = this.state.form;
  //     let value = true;
  //     if (this.state.editOption) {
  //       value = !isEqual(this.state.form, this.props.selecteditem);
  //     }
  //     let validLicensePlateFormat = /^\d{4}[A-Za-z]{3}$/;
  //     let validLicensePlateFormatArabic = /^[\u0621-\u064A]\s[\u0621-\u064A]\s[\u0621-\u064A]\s[\d٠-٩]{4}$/;
  //     if(validLicensePlateFormat.test(vehicleLicensePlate) || validLicensePlateFormatArabic.test(vehicleLicensePlate)) {
  //       this.setState({
  //         vehicleLicensePlateError: false
  //       })
  //     } else {
  //       this.setState({
  //         vehicleLicensePlateError: true
  //       })
  //     }
  //     if(onLease){
  //       if (
  //         label &&
  //         label.trim().length &&
  //         vehicleLicensePlate &&
  //         vehicleLicensePlate.trim().length &&
  //         validLicensePlateFormat.test(vehicleLicensePlate) || validLicensePlateFormatArabic.test(vehicleLicensePlate) &&
  //         deliveryDate &&
  //         leaseEndDate&&
  //         leaseEndDate > leaseStartDate &&
  //         value
  //       ) {
  //         this.setState({
  //           isVisableUserBtn: true,
  //         });
  //       }
  //       else {
  //         this.setState({
  //           isVisableUserBtn: false,
  //         });
  //       }
  //     }
  // else{
  //   if (
  //     label &&
  //     label.trim().length &&
  //     vehicleLicensePlate &&
  //     vehicleLicensePlate.trim().length &&
  //     validLicensePlateFormat.test(vehicleLicensePlate) || validLicensePlateFormatArabic.test(vehicleLicensePlate) &&
  //     // fuel_type !== '' &&
  //     // fuel_type !== undefined &&
  //     // deliveryDate &&
  //     // leaseEndDate&&
  //     // leaseEndDate > leaseStartDate &&
  //     value
  //   ) {
  //     this.setState({
  //       isVisableUserBtn: true,
  //     });
  //   }
  //   else {
  //     this.setState({
  //       isVisableUserBtn: false,
  //     });
  //   }
  // }

  //   }

  getFuelEfficiency = async (type) => {
    let result = await axios.get(`/api/vehicles/fuelefficiency?type=${type}`);
    const [key] = Object.keys(result.data);
    const value = result.data[key];
    this.setState({
      form: {
        ...this.state.form,
        fuelEfficiency: value || 0,
      },
    });
    return value;
  };

  submitWasl = (vehicle) => {
    const { waslCompanyRefKey } = this.props?.serversettings?.attributes || {};
    if (waslCompanyRefKey) {
      const {
        number,
        leftLetter,
        rightLetter,
        plateType,
        middleLetter,
        sequenceNumber,
      } = vehicle.attributes;
      const uniqueId = this.state.vehicleTracker?.uniqueId||"";
      if (
        number &&
        leftLetter &&
        rightLetter &&
        plateType &&
        middleLetter &&
        sequenceNumber &&
        uniqueId
      ) {
        instance
          .post(`${process.env.REACT_APP_WASL}/handleSocketRequest`, {
            hook: "registerVehicle",
            account_id: this.props.serversettings.id,
            data: {
              uniqueId,
              sequenceNumber,
              activity: "DEFAULT",
              attributes: {
                rightLetter,
                number,
                leftLetter,
                middleLetter,
                plateType,
              },
            },
            hook_prefix: waslCompanyRefKey,
          })
          .then((response) => {
            // if(response.status === 200 && response.data && response.data.success) {
            this.setState({
              waslStatus: (
                <span className="loading-status-text">
                  <DoneAllIcon className="status-icon" /> Done
                </span>
              ),
            });
            if (response.result && response.result.referenceKey) {
              this.handleChangeForAttributesValues("WASLKey", {
                target: { value: response.result.referenceKey },
              });
              this.uc_submit(true);
            }
            // }
          })
          .catch((error) => {
            let res = error?.response?.data || {};
            let check = res && res.data && res.data.result;
            if (check && check.referenceKey) {
              this.handleChangeForAttributesValues("WASLKey", {
                target: { value: check.referenceKey },
              });
              this.uc_submit(true);
            }

            this.setState({
              waslStatus: (
                <span className="loading-status-text">
                  <ErrorOutlineIcon className="status-icon" /> invalid form
                </span>
              ),
            });
            this.handleAfterResponse();
          });
      } else {
        this.setState({
          waslStatus: (
            <span className="loading-status-text">
              <ErrorOutlineIcon className="status-icon" /> incomplete form
            </span>
          ),
        });
        this.handleAfterResponse();
      }
    } else {
      this.handleAfterResponse();
    }
  };

  mapMakeOption = (item) => {
    const label =
      item?.makeName || item?.name || item?.make || item?.label || "";
    const id = item?.id ?? label;
    return { id, label, value: label, key: id };
  };

  fetchMakes = (page = 1, make = "", reset = false) => {
    if (this.makesPaginationRef.loading) {
      return Promise.resolve(this.state.allMakes);
    }

    this.makesPaginationRef.loading = true;
    this.setState({ makesLoading: true });

    return instance({
      method: "GET",
      url: `/api/makes/get?page=${page}&limit=20&make=${encodeURIComponent(make || "")}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        const options = (response?.data || []).map(this.mapMakeOption);
        const nextPage = response?.page ?? page;

        this.makesPaginationRef = {
          page: nextPage,
          hasNext: Boolean(response?.hasNext),
          search: make,
          loading: false,
        };

        this.setState((prev) => {
          const merged = reset ? options : [...prev.allMakes, ...options];
          const allMakes = merged.filter(
            (item, index, arr) =>
              arr.findIndex((x) => x.id === item.id) === index,
          );
          return { allMakes, makesLoading: false };
        });

        return options;
      })
      .catch((error) => {
        this.makesPaginationRef.loading = false;
        this.setState({ makesLoading: false });
        errorHandler(error, this.props.dispatch);
        return [];
      });
  };

  fetchMake = () => {
    this.fetchMakes(1, "", true);
  };

  onMakeInputChange = (inputValue, { action }) => {
    if (action !== "input-change") return;

    if (this.makeSearchTimeout) {
      clearTimeout(this.makeSearchTimeout);
    }

    this.makeSearchTimeout = setTimeout(() => {
      this.fetchMakes(1, inputValue, true);
    }, 300);
  };

  loadMoreMakes = () => {
    const { hasNext, loading, page, search } = this.makesPaginationRef;
    if (!hasNext || loading) return;
    this.fetchMakes(page + 1, search, false);
  };

  render() {
    let { selecteditem } = this.props;

    if (
      selecteditem.id !== this.state.vehicleId &&
      this.props.trackersApiResponce
    ) {
      this.dataFormatting();
    }
    return (
      <div style={{ height: "100%", position: "relative", zIndex: 9999 }}>
        {this.state.addOption && (
          <>
            {/* Add Vehicle */}
            <AddVehicle
              translate={this.props.translate}
              {...this.state}
              {...this.props}
              users={this.props.users}
              dispatch={this.props.dispatch}
              logInUsers={this.props.logInUsers}
              onClose={this.onCloseSubModal}
              formSubmit={this.uc_submit}
              changeAttribute={this.changeAttribute}
              handleChange={this.handleChange}
              handleChangeForAttributesValues={
                this.handleChangeForAttributesValues
              }
              handleChangeLicenseExpDate={this.handleChangeLicenseExpDate}
              setExpirationTime={this.setExpirationTime}
              onChangedDevice={this.onChangedDevice}
              onMakeInputChange={this.onMakeInputChange}
              loadMoreMakes={this.loadMoreMakes}
              getVehicleData={this.getVehicleData}
              form={this.state.form}
              buttonText={"sharedCreate"}
              isHaveAccess={"vehicleCreate"}
              areaList={checkPrivileges("area") ? this.props.areaList : []}
            />
          </>
        )}
        {this.state.editOption && (
          <AddVehicle
            {...this.props}
            {...this.state}
            users={this.props.users}
            translate={this.props.translate}
            dispatch={this.props.dispatch}
            serversettings={this.props.serversettings}
            logInUsers={this.props.logInUsers}
            onClose={this.onCloseSubModal}
            formSubmit={this.uc_submit}
            changeAttribute={this.changeAttribute}
            handleChange={this.handleChange}
            handleChangeForAttributesValues={
              this.handleChangeForAttributesValues
            }
            handleChangeLicenseExpDate={this.handleChangeLicenseExpDate}
            setExpirationTime={this.setExpirationTime}
            onChangedDevice={this.onChangedDevice}
            onMakeInputChange={this.onMakeInputChange}
            loadMoreMakes={this.loadMoreMakes}
            getVehicleData={this.getVehicleData}
            buttonText={"update"}
            isHaveAccess={"vehicleUpdate"}
            areaList={checkPrivileges("area") ? this.props.areaList : []}
          />
        )}
        {this.state.selectedVehicle &&
        this.props.showItemDetail &&
        this.props.trackersApiResponce ? (
          <EditItem
            logInUsers={this.props.logInUsers}
            currentLocation={this.props.currentLocation}
            selectedItem={this.state.selectedVehicle}
            handleClose={this.onCloseSubModal}
            devicesIcons={this.props.devicesIcons}
          />
        ) : !this.state.addOption && !this.state.editOption ? (
          <Loader />
        ) : null}
        {this.props.showWaslShortList && this.props.vehicleHookData ? (
          <WaslShortList
            logInUsers={this.props.logInUsers}
            currentLocation={this.props.currentLocation}
            handleClose={this.onCloseSubModal}
            devicesIcons={this.props.devicesIcons}
            vehicleHookData={this.props.vehicleHookData}
            sequenceNumber={this.props.sequenceNumber}
          />
        ) : null}
        {this.state.showVinConfirmDialog && (
          <ConfirmDialoag
            onCancel={this.handleVinConfirmNo}
            onOk={this.handleVinConfirmYes}
            title={this.props.translate("vinDecoderDataFound")}
            CancelText="no"
            OkText="yes"
          >
            <p>{this.props.translate("vinDecoderDataFoundMessage")}</p>
            {this.getVinConfirmPreviewText() && (
              <p style={{ fontWeight: 600 }}>
                {this.getVinConfirmPreviewText()}
              </p>
            )}
            {this.renderVinConfirmDetails()}
          </ConfirmDialoag>
        )}
      </div>
    );
  }
}

const mapState = (state) => ({
  logInUsers: state.logInUsers,
  serversettings: state.ServerSetting,
  themecolors: state.themeColors,
  users: state.users,
  cities: state.Cities.cities,
});
const mapStateToProps = connect(mapState);
export const VehicleModal = mapStateToProps(vehicleModal);

const LoadingIndicator = () => {
  return (
    <span className="status-icon">
      <span className="loading-dot" style={{ animationDelay: "0ms" }} />
      <span className="loading-dot" style={{ animationDelay: "160ms" }} />
      <span className="loading-dot" style={{ animationDelay: "320ms" }} />
    </span>
  );
};
